import React from 'react';

const stages = [
  {
    num: '01',
    stage: 'Sourcing',
    title: 'Strategic Sector Mapping',
    desc: 'Synthesizes macro industry profit pools and builds custom alpha theses to identify, rank, and screen off-market targets before an auction process forms.',
    bullets: ['Thematic Sector & Profit-Pool Mapping', 'Automated CIM Triaging & Screening', 'Alpha Thesis & Red-Flag Formulation', 'Acquirer & Competitor Universe Mapping'],
  },
  {
    num: '02',
    stage: 'Diligence',
    title: 'Strategic & Investment Diligence',
    desc: 'Reconciles raw dataroom evidence with outside-in market intelligence to stress-test commercial moats, technical defensibility, and downside risk.',
    bullets: ['VDR Ingestion & DD Checklist Audit', 'Market Dynamics & Addressable TAM', 'Deterministic Valuation & Synergies', 'Adversarial Diligence & IC Verdict'],
  },
  {
    num: '03',
    stage: 'Value Creation',
    title: 'Topline Alpha & Expansion',
    desc: 'Deploys agentic capabilities inside portfolio assets to unlock new revenue streams, launch adjacent markets, and transform legacy business models.',
    bullets: ['Continuous PortCo Telemetry Monitoring', 'Programmatic Bolt-On M&A Pipelines', 'Topline & Adjacent Market Expansion', 'Boardroom & Operating Committee Packs'],
  },
  {
    num: '04',
    stage: 'Strategic Exit',
    title: 'Multiple Realization',
    desc: 'Reverse-engineers strategic acquirer capability gaps 12 months early, packaging mathematically verified equity stories that command premium multiples.',
    bullets: ['Strategic Acquirer Profiling & Gap Mapping', 'Vendor Commercial Diligence (VDD) Defense', 'Clean-Room & Certified Evidence Repositories', 'Exit Equity Story & Multiple Positioning'],
  },
];

// Section 2 — The full deal lifecycle (4 stages).
export const LifecycleSection = () => (
  <section className="py-24 sm:py-32 px-6 sm:px-10 lg:px-16 border-b border-stone-200/80 bg-[#FFFFFF]">
    <div id="lifecycle" className="scroll-mt-20 w-full max-w-[1600px] mx-auto">

      <div className="max-w-3xl mb-14 sm:mb-16">
        <span className="mono text-[10px] uppercase tracking-widest text-[#F58220] font-semibold block mb-2.5">Autonomous Workflow Orchestration</span>
        <h2 className="text-3xl sm:text-5xl font-medium tracking-tight text-stone-950 mb-3.5">The full deal lifecycle. Accelerated.</h2>
        <p className="text-base sm:text-lg text-stone-700 leading-relaxed font-sans max-w-2xl">
          Frontier deploys across each stage of the deal lifecycle to accelerate complex workflows — empowering teams to stress-test more hypotheses with deep sector-specific context and underwrite with absolute conviction.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 items-stretch">
        {stages.map((s) => (
          <div key={s.num} className="p-7 rounded-3xl bg-[#090E1A] border border-white/10 flex flex-col group hover:border-[#F58220]/50 transition-colors duration-300">
            <div className="min-h-[170px]">
              <div className="mb-4 font-mono text-xs text-white/40">
                <span className="font-bold text-[#F58220]">{s.num}</span>
                <span className="mx-2">/</span>
                <span className="uppercase tracking-wider text-white/50">{s.stage}</span>
              </div>
              <h3 className="text-xl font-bold text-white mb-3 tracking-tight">{s.title}</h3>
              <p className="text-[13px] text-white/55 leading-relaxed font-sans">{s.desc}</p>
            </div>
            <div className="pt-4 border-t border-white/10">
              <ul className="space-y-2.5 text-xs font-sans text-white/60">
                {s.bullets.map((b) => (
                  <li key={b} className="flex items-start gap-2.5">
                    <span className="text-white/25 select-none">—</span>
                    <span>{b}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);
